import { AtvKeyboard } from './AtvKeyboard';
import { InputField } from '@lightningjs/ui';
import { Log } from '@lightningjs/sdk';

export class AtvKeyboardService {
  static init(parentElement, kbOpt = {}) {
    if (AtvKeyboardService._instance) {
      Log.error('Cannot instantiate FullKeyboard twice');
      return;
    }
    AtvKeyboardService._instance = new AtvKeyboardService(parentElement, kbOpt);
  }

  static get instance() {
    if (!AtvKeyboardService._instance) {
      Log.error('Cannot return FullKeyboardService instance before init() was called');
      return undefined;
    }
    return AtvKeyboardService._instance;
  }

  static removeInstance() {
    if (!AtvKeyboardService._instance) return;
    AtvKeyboardService._instance.parentEl.patch({
      KB: undefined,
    });
    AtvKeyboardService._instance = undefined;
  }

  constructor(parentElement, kbOpt) {
    parentElement.patch({
      KB: {
        keyboardConfig: kbOpt,
        type: AtvKeyboard,
        signals: {
          onFinished: this.onKeyboardClosed.bind(this),
          onInputChanged: this.onInputChanged.bind(this),
        },
      },
    });
    this.keyboardElement = parentElement.tag('KB');
    this.parentEl = parentElement;
  }

  set emailMode(bool) {
    let conf = this.keyboardElement.keyboardConfig;
    conf.layoutOptions.emailMode = bool;
    this.keyboardElement.keyboardConfig = conf;
  }

  set numpadMode(bool) {
    let conf = this.keyboardElement.keyboardConfig;
    conf.layoutOptions.numpadMode = bool;
    this.keyboardElement.keyboardConfig = conf;
  }

  //TODO use callback to signal it being closed or something else?
  connect(inputField, finishedCallback = undefined, changedCallback = undefined) {
    if (!(inputField instanceof InputField)) {
      Log.error('Can only connect FullKeyboard to type InputField');
    }
    this.keyboardElement.inputField = inputField;
    this._callback = finishedCallback;
    this._changedCallback = changedCallback;
    this.keyboardElement.show();
  }

  get isOpen() {
    return this.keyboardElement.isShown;
  }

  get keyboard() {
    return this.keyboardElement;
  }

  onKeyboardClosed() {
    if (this._callback) this._callback();
  }

  onInputChanged(args) {
    if (this._changedCallback) this._changedCallback(args);
  }
}
